// Web Push helper
import client from "@/lib/api";

const urlBase64ToUint8Array = (base64String) => {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; ++i) out[i] = raw.charCodeAt(i);
  return out;
};

export const isPushSupported = () =>
  typeof window !== "undefined" && "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

export const getPushPermission = () => (isPushSupported() ? Notification.permission : "denied");

export const registerServiceWorker = async () => {
  if (!("serviceWorker" in navigator)) return null;
  try {
    let reg = await navigator.serviceWorker.getRegistration();
    if (!reg) reg = await navigator.serviceWorker.register("/service-worker.js");
    await navigator.serviceWorker.ready;
    return reg;
  } catch { return null; }
};

export const subscribeToPush = async () => {
  if (!isPushSupported()) throw new Error("Push not supported on this browser");
  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw new Error("Permission denied");
  const reg = await registerServiceWorker();
  if (!reg) throw new Error("Service worker unavailable");
  const { data } = await client.get("/push/vapid-public-key");
  if (!data.public_key) throw new Error("Push not configured on server");
  const sub = await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(data.public_key),
  });
  const raw = sub.toJSON();
  await client.post("/push/subscribe", {
    endpoint: raw.endpoint,
    keys: raw.keys,
    user_agent: navigator.userAgent,
  });
  return sub;
};

export const unsubscribeFromPush = async () => {
  const reg = await registerServiceWorker();
  if (!reg) return;
  const sub = await reg.pushManager.getSubscription();
  if (sub) {
    try { await client.post("/push/unsubscribe", { endpoint: sub.endpoint }); } catch (err) { if (process.env.NODE_ENV !== "production") console.warn("push unsub failed:", err); }
    await sub.unsubscribe();
  }
};

export const currentSubscription = async () => {
  const reg = await registerServiceWorker();
  if (!reg) return null;
  return reg.pushManager.getSubscription();
};

export const testPush = async () => {
  await client.post("/push/test");
};
